import ApolloClient from "apollo-client"
import { ApolloLink } from "apollo-link"
import { RetryLink } from "apollo-link-retry"
import { createUploadLink } from "apollo-upload-client"
import { InMemoryCache } from "apollo-cache-inmemory"

import config from "../../config"

/**
 * @param {fetch} if `fetch` is truthy, then we're using
 * apollo client on the server.
 *
 * @returns {function} creates an instance of ApolloClient
 */
const createClient = (fetch?: any) => {
  const isClient = typeof window !== "undefined"
  const cache = new InMemoryCache()

  const uploadLink = createUploadLink({
    fetch,
    uri: config.api.baseUrl + (isClient ? window?.location.search : ""), // Append query string to baseUrl for testing purposes. During build-time window is not defined, so the 'isClient' check is required
    credentials: "include"
  })

  /*
   * Adding this link to the ApolloClient link will retry the failed requests
   * if a network or server error occured. For mutations we do not retry the request
   * because we have mutations that are not meant to be fired more than once.
   */
  const retryLink = new RetryLink({
    attempts: {
      max: 3,
      retryIf: (error, { query: { definitions } }) => {
        const hasMutationOperation =
          definitions.filter(
            definition => definition.kind === "OperationDefinition" && definition.operation === "mutation"
          ).length > 0

        return !!error && !hasMutationOperation
      }
    }
  })

  const client = new ApolloClient({
    link: ApolloLink.from([retryLink, uploadLink]),
    cache
  })

  return client
}

export default createClient
